import DashboardIcon from '@mui/icons-material/Dashboard'
import { Button, Grid, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import MassAssignmentModal from '../../../../shared/components/modals/MassAssignmentModal'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { tableScreenStyles } from '../../../../shared/styles/TableScreenStyles'

interface ActionsSectionProps {
  rowsSelected: any[]
  onCreateCourse: () => void
  onOrganizeCourses: () => void
  onMassAssignment: (data: any) => void
  onFilterChange: (options: any) => void
  tags: any
}

export default function ActionsSection({
  rowsSelected,
  onCreateCourse,
  onMassAssignment,
  onOrganizeCourses,
  onFilterChange,
  tags
}: ActionsSectionProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const tableClass = tableScreenStyles(theme)
  const massEditableFields = ['countries', 'brand', 'line', 'resourcetype', 'role', 'languages', 'visibility']
  const status = [
    { id: 0, name: 'Inactivo' },
    { id: 1, name: 'Activo' },
    { id: 2, name: 'Borrador' }
  ]
  const visibility = [
    { id: 0, name: t('close') },
    { id: 1, name: 'VIP' },
    { id: 2, name: 'Pago' }
  ]
  const optionsData = [
    { data: status, code: 'status', column: 'status' },
    { data: visibility, code: 'visibility', column: 'visibility' },
    { data: tags, code: 'categories', column: 'tag_id' }
  ]

  return (
    <Grid
      container
      justifyContent={isMobile ? 'flex-start' : 'space-between'}
      spacing={1}
      alignItems="center"
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: isMobile ? 'flex-start' : 'space-between'
      }}
    >
      <Grid
        item
        xs={12}
        sm={5}
        sx={{
          ...tableClass.actionsResponsive,
          paddingLeft: 0,
          paddingTop: 0,
          width: isMobile ? '100%' : undefined,
          mb: isMobile ? 2 : 0
        }}
      >
        {rowsSelected.length === 0 && (
          <Button
            id="btn-create-course"
            variant="outlined"
            color="secondary"
            onClick={onCreateCourse}
            sx={{ justifyContent: 'flex-start' }}
          >
            {t('admin.courses.create-course')}
          </Button>
        )}
        <MassAssignmentModal rows={rowsSelected} fields={massEditableFields} handleSubmit={onMassAssignment} />
      </Grid>
      <Grid
        item
        xs={12}
        sm={7}
        gap={4}
        sx={{
          ...tableClass.actionsResponsiveRight,
          width: isMobile ? '100%' : undefined,
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center'
        }}
        display="flex"
      >
        <Button
          id="btn-management-course"
          variant="text"
          color="secondary"
          onClick={onOrganizeCourses}
          endIcon={<DashboardIcon />}
          fullWidth={isMobile}
          sx={{ justifyContent: 'flex-start' }}
        >
          {t('admin.courses.organize-courses')}
        </Button>
        <AdminContentFilter data={optionsData} handleClick={onFilterChange} />
        <CountriesFilter />
      </Grid>
    </Grid>
  )
}
